/* src/app/components/analytics/email-thread/email-thread.component.scss */
.title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.value {
  font-size: 12px;
}
.line {
  stroke: rgb(0, 0, 0);
}
rect {
  fill: white;
  stroke-width: 1;
  stroke: black;
}
.email-hover rect {
  fill: rgb(230, 230, 230);
}
.email-selected rect {
  fill: #ffc107;
}
.email-time-sent {
  fill: gray;
}
.duplicate-email-number {
  fill: black;
}
.email-not-available rect {
  fill: white;
  stroke: rgb(0, 0, 0);
}
.email-not-available text {
  fill: black;
}
:host-context(.dark-theme) .mat-toolbar .mat-mdc-button {
  color: white;
}
:host-context(.dark-theme) .mat-sidenav .mat-mdc-card,
:host-context(.dark-theme) .mat-sidenav .mat-mdc-card-content {
  background: #2c2c2c;
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.6);
}
:host-context(.dark-theme) .value {
  color: ghostwhite;
}
:host-context(.dark-theme) .line {
  stroke: #908f8f;
}
:host-context(.dark-theme) rect {
  fill: #363636;
  stroke-width: 1;
  stroke: #908f8f;
  -webkit-filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.35));
  filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.35));
}
:host-context(.dark-theme) .email-hover rect {
  fill: #585858;
}
:host-context(.dark-theme) .email-selected rect {
  fill: #eab63c;
}
:host-context(.dark-theme) text {
  fill: white;
}
:host-context(.dark-theme) .duplicate-email-number {
  fill: white;
}
:host-context(.dark-theme) .email-selected .email-date-sent {
  fill: rgb(0, 0, 0);
}
:host-context(.dark-theme) .email-selected .email-time-sent {
  fill: #454545;
}
:host-context(.dark-theme) .email-selected .duplicate-email-number {
  fill: #454545;
}
:host-context(.dark-theme) .email-not-available rect {
  fill: #363636;
  stroke: #908f8f;
  -webkit-filter: none;
  filter: none;
}
:host-context(.dark-theme) .email-not-available text {
  fill: white;
}
/*# sourceMappingURL=email-thread.component.css.map */
